module.exports = __webpack_public_path__ + "media/images/Bars/icon-back-incircle@3x-ba1a23a06a3d56d9859cdf92c4fa51f5.png";